import { memo, useEffect, useState, useRef, useMemo } from 'react';
import { useStore } from '@/store';
import Marquee from 'react-fast-marquee';
import { EventCardInfo } from '@/store/types';
import { useSpring, animated, to } from '@react-spring/web';
import styles from './index.module.scss';
import { getAssetUrl } from '@/utils/common';
// import { random } from '../../generatePosition';
import { CARD_WIDTH, CARD_HEIGHT, CARD_MARGIN, screenWidth, screenHeight, marginLeft, marginTop, LocalMaterialMap } from '../../config';
import { Image } from '@shuwen/wenlv-web-activity-library';
import { Carousel } from 'antd';




export type ShufflePhase = 'idle' | 'center' | 'shake' | 'return';

// 计算屏幕中心点
const centerX = marginLeft + screenWidth / 2;
const centerY = marginTop + screenHeight / 2;

interface EventCardProps {
  card: EventCardInfo;
  index: number;
  shufflePhase: ShufflePhase;
  visible: boolean;
}

const EventCard = ({ card, index, shufflePhase, visible }: EventCardProps) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scrollIntervalRef = useRef<number | null>(null);
  const isScrollingDownRef = useRef(true);
  const timerRef = useRef<any>(null);

  const setEventCardId = useStore((state) => state.setEventCardId);
  const eventCardId = useStore((state) => state.eventCardId);
  const [scale, setScale] = useState(card.scale);
  const [needsMarquee, setNeedsMarquee] = useState(false);
  const nameRef = useRef<HTMLHeadingElement>(null);


  const material = useMemo(()=>{
    if(!visible)return null;
  console.log('material',LocalMaterialMap.get(card.entity_id));

    return LocalMaterialMap.get(card.entity_id);
  },[card.entity_id,visible]);


  const isShake = shufflePhase === 'shake' || shufflePhase === 'center';


  // 基础动画
  const spring = useSpring({
    key: card.entity_id,
    from: {
      angle: (index * 120) % 360,
      // angle: 0,
    },
    to: {
      angle: (index * 120) % 360 + 360
      // angle: 0
    },
    loop: true,
    pause: visible,
    // config: { duration: isShake? 200 : 6 * 1000  },
    config: { duration: 6 * 1000 },
  });


  // 缩放动画
  const scaleSpring = useSpring({
    scale: visible ? 5 : scale,
    height: visible ? 246 : 130,
    config: { duration: 500 }
  });


  const positionSpringConfig = visible || isShake ? {
    x: centerX - CARD_WIDTH / 2,
    y: centerY - CARD_HEIGHT / 2,
  } : {
    x: card.x,
    y: card.y,
  }

  // 定位动画
  const positionSpring = useSpring({
    // key: card.entity_id,
    ...positionSpringConfig,
    // loop: shufflePhase === 'shake' ? { reverse: true } : false,
    config: {
      // tension: 300,
      // friction: 10,
      // duration: 300
    }
  });

  useEffect(() => {
    const randomScale = () => {
      if (Math.random() < 0.2) {
        setScale(card.scale * 1.5);
        setTimeout(() => {
          setScale(card.scale);
        }, 3 * 1000);
      }
    };

    const interval = setInterval(randomScale, 5000 + Math.random() * 2000);
    return () => clearInterval(interval);
  }, [card.scale]);

  // 检测内容是否需要滚动
  useEffect(() => {
    if (visible) {
      // 延迟检测，等待动画完成
      const timer = setTimeout(() => {
        if (nameRef.current) {
          const element = nameRef.current;
          const needsScroll = element.scrollWidth > element.clientWidth;
          setNeedsMarquee(needsScroll);
        }
      }, 600); // 等待动画完成

      return () => clearTimeout(timer);
    } else {
      // 重置状态
      setNeedsMarquee(false);
    }
  }, [visible, card.name, card.summary]);
  useEffect(() => {
    const cleanup = () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      if (scrollIntervalRef.current) {
        clearInterval(scrollIntervalRef.current);
        scrollIntervalRef.current = null;
      }
    };

    if (visible) {
      if (scrollIntervalRef.current) {
        cleanup();
      }
      const el = scrollRef.current;
      if (el && el.scrollHeight > el.clientHeight) {
        const startScrollCycle = () => {
          timerRef.current = setTimeout(() => {
            startScrollAnimation();
          }, 10000); // 初始延迟5秒
        };

        const startScrollAnimation = () => {
          if (!el) return;
          const delay = 100;
          const scrollStep = 1;
          scrollIntervalRef.current = window.setInterval(() => {
            if (isScrollingDownRef.current) {
              if (el.scrollTop + el.clientHeight < el.scrollHeight) {
                el.scrollTop += scrollStep;
              } else {
                clearInterval(scrollIntervalRef.current!);
                isScrollingDownRef.current = false;
                setTimeout(startScrollAnimation, 5000); // 到底后等待5s
              }
            } else {
              if (el.scrollTop > 0) {
                el.scrollTop -= scrollStep;
              } else {
                clearInterval(scrollIntervalRef.current!);
                isScrollingDownRef.current = true;
                setTimeout(startScrollAnimation, 5000); // 回到顶部后等待5s
              }
            }
          }, delay);
        };


        startScrollCycle();

        return () => cleanup();
      }
      return () => cleanup();
    } else {
      cleanup();
    }

  }, [visible, eventCardId]);


  return (
    <animated.div
      style={{
        // transform: to(
        //   [shakeSpring.angle, shakeSpring.rotate],
        //   (angle: number, rotate: number) => {
        //     const radius = 15;
        //     const offsetX = Math.cos((angle * Math.PI) / 180) * radius;
        //     const offsetY = Math.sin((angle * Math.PI) / 180) * radius;
        //     return `translate(${offsetX}px, ${offsetY}px) rotate(${rotate}deg)`
        //   }
        // )
        position: 'absolute',
        zIndex: visible ? 11 : 1,
        ...positionSpring,
      }}
    >
      <animated.div
        className={styles.card}
        style={{
          transform: to(
            [spring.angle, scaleSpring.scale],
            (angle: number, scale: number) => {
              const radius = 15;
              const offsetX = Math.cos((angle * Math.PI) / 180) * radius;
              const offsetY = Math.sin((angle * Math.PI) / 180) * radius;
              return `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
            }
          ),
          height: scaleSpring.height,
        }}
        onClick={() => {
          setEventCardId(visible ? null : card.entity_id);
        }}
      >
        <div className={styles.cardContent}>
          {
            material?.length ? (
              <Carousel autoplay>
                {
                  material?.map((item: string, index: number) => (
                    <div key={index} className={styles.imageContainer}>
                      <Image src={item} alt={card.name} />
                    </div>
                  ))
                }
              </Carousel>
            ):(
              <div className={styles.imageContainer}>
                <Image src={card.image} alt={card.name} />
              </div>
            )
          }
        
          <div className={styles.info}
          // style={card.data ? {} : {justifyContent:"center"}}
          >
            {visible ? (
              <Marquee>
                <h3 ref={nameRef} className={styles.nameMarquee}>
                  <span>{card.name}</span>
                </h3>
              </Marquee>
            ) : (
              <h3 ref={nameRef} className={styles.name}>{card.name}</h3>
            )}
            {
              card.year && <span className={styles.date}>{card.year?.includes('年') ? card.year : card.year + '年'}</span>
            }
          </div>
          <div className={styles.animate_con}>
            <img src={getAssetUrl('images/landmark/type.svg')} alt="" />
            <p ref={scrollRef} >{card.summary?.replace(/\n/g, '\n        ')}</p>
          </div>
        </div>
      </animated.div>
    </animated.div>
  );
};

export default memo(EventCard); 